import type { Product } from '../types'
import { formatCurrency } from '../lib/utils'
import { useCartStore } from '../stores/cartStore'

interface ProductCardProps {
  product: Product
  onClick: () => void
}

function ProductCard({ product, onClick }: ProductCardProps) {
  const addItem = useCartStore((state) => state.addItem)

  const handleAddToCart = (e: React.MouseEvent) => {
    e.stopPropagation()
    addItem(product, 1)
  }

  const isOutOfStock = product.quantity <= 0

  return (
    <div
      className="card overflow-hidden cursor-pointer hover:shadow-md transition-shadow"
      onClick={onClick}
    >
      <div className="aspect-square bg-gray-100 relative overflow-hidden">
        {product.imageUrl ? (
          <img
            src={product.imageUrl}
            alt={product.name}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-gray-400">
            <svg
              className="w-16 h-16"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
          </div>
        )}

        {isOutOfStock && (
          <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
            <span className="bg-white px-4 py-2 rounded-lg font-semibold text-gray-900">
              Stok Habis
            </span>
          </div>
        )}
      </div>

      <div className="p-4">
        <h3 className="font-semibold text-gray-900 mb-1 line-clamp-2">
          {product.name}
        </h3>
        
        {product.category && (
          <p className="text-xs text-gray-500 mb-2">{product.category}</p>
        )}

        <div className="flex items-center justify-between mt-3">
          <span className="text-lg font-bold text-primary font-mono">
            {formatCurrency(product.price)}
          </span>
          
          <button
            onClick={handleAddToCart}
            disabled={isOutOfStock}
            className="btn-primary text-sm px-3 py-1.5"
          >
            + Keranjang
          </button>
        </div>

        {product.quantity > 0 && product.quantity <= 5 && (
          <p className="text-xs text-warning mt-2">
            Tersisa {product.quantity} item
          </p>
        )}
      </div>
    </div>
  )
}

export default ProductCard
